export default {
	default: [''],
	icon: ['btn-action-ribbon--icon-only'],
	save: ['btn-action-ribbon--save'],
	iconsave: ['btn-action-ribbon--icon-only-save']
};
